import type { SiparisAdresi as AdresGirdisi } from "@koclukpanel/contracts";
import { api } from "./api";
import type { MagazaVitrini, Siparis, VeliKararYaniti, VeliSiparisOnayi } from "./magaza-tipleri";

/**
 * MAĞAZA UÇLARI — öğrenci + veli (dalga 2 / 7a). Yollar ve gövdeler `apps/api/src/modules/oyun/magaza.controller.ts`
 * ile birebir; kapsam ve IDOR SUNUCUDA, bu dosya yalnız ince çağrılar.
 *
 * Modül kapalıyken sunucu 404 döner; ekranlar bunu "mağaza kapalı" diye gösterir, hata saymaz.
 */

/**
 * Vitrin: bakiye, ürünler ve `siparisVerilemez` (7b madde 7 — hesap ACTIVE değilse `{kod, durum, mesaj}`, değilse
 * null). Ekran bu alan doluyken "Sipariş ver"i kapatır ve `mesaj`ı olduğu gibi gösterir.
 */
export function magazaVitrini(): Promise<MagazaVitrini> {
  return api("/oyun/magaza/urunler");
}

/**
 * `istekKimligi` İSTEMCİ UUID'si: ağ hatasında yeniden gönderim AYNI siparişi döndürür, puan iki kez düşmez.
 * Kimliği ekran, form açılınca bir kez üretir.
 */
export function siparisVer(govde: { urunId: string; istekKimligi: string }): Promise<Siparis> {
  return api("/oyun/magaza/siparisler", { yontem: "POST", govde });
}

export function siparislerim(): Promise<Siparis[]> {
  return api("/oyun/magaza/siparislerim");
}

export function siparisGetir(id: string): Promise<Siparis> {
  return api(`/oyun/magaza/siparisler/${encodeURIComponent(id)}`);
}

/** 18 ve üstü öğrenci kendi adresini verir. Gövde `{ adres }` (sözleşme `adresIstegiSemasi`). */
export function siparisAdresVer(id: string, adres: AdresGirdisi): Promise<Siparis> {
  return api(`/oyun/magaza/siparisler/${encodeURIComponent(id)}/adres`, {
    yontem: "POST",
    govde: { adres },
  });
}

export function siparisIptalEt(id: string): Promise<Siparis> {
  return api(`/oyun/magaza/siparisler/${encodeURIComponent(id)}/iptal`, { yontem: "POST" });
}

// --- Veli (`odul.siparis.onayla`, LINKED) ---------------------------------------------------------

export function veliSiparisOnaylari(): Promise<VeliSiparisOnayi[]> {
  return api("/veli/siparis-onaylari");
}

/** Onay ve adres TEK istekte: sunucu kilit → adres → PREPARING'i bir işlemde yapar. Gövde `{ adres }`. */
export function veliSiparisOnayla(id: string, adres: AdresGirdisi): Promise<VeliKararYaniti> {
  return api(`/veli/siparis-onaylari/${encodeURIComponent(id)}/onayla`, {
    yontem: "POST",
    govde: { adres },
  });
}

export function veliSiparisReddet(id: string): Promise<VeliKararYaniti> {
  return api(`/veli/siparis-onaylari/${encodeURIComponent(id)}/reddet`, { yontem: "POST" });
}
